<template>
  <b-col lg="12">


    <b-form @submit.prevent="onSubmit" class="p-1">
      <b-row class="mb-4">
        <b-col>
          <router-link v-if="mode!='create'" :to="{name:'SingleCategory',params:{slug:category.slug}}">
       <span class="badge badge-primary p-2 rounded-pill">محصولات دسته: {{
           category.products_count
         }}</span>
          </router-link>
        </b-col>

        <b-col class="text-left">
          <div class="custom-control custom-switch">
            <input type="checkbox" name="check-button" class="custom-control-input" v-model="form.status"
                   :id="`category_status_${generateRandomString}`"/>
            <label class="custom-control-label" :for="`category_status_${generateRandomString}`">وضعیت نمایش</label>
          </div>
        </b-col>
      </b-row>
      <b-form-row>
        <b-col lg="2">
          <form-group :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="نام دسته"
                  class="mb-4"
              >
                <b-form-input
                    v-model="form.name"
                    type="text"
                    placeholder="نام دسته"
                    :class="{ invalid }"
                    class="rounded-pill"
                ></b-form-input>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
        <b-col lg="2">
          <form-group :validations="$v.form.slug">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="slug"
                  class="mb-4"
              >
                <b-form-input
                    v-model="form.slug"
                    type="text"
                    placeholder="slug"
                    :class="{ invalid }"
                    class="rounded-pill"
                ></b-form-input>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
        <b-col lg="2">
          <form-group :validations="$v.form.parent_id">
            <div slot-scope="{ errors, invalid }">
              <label for="">
                زیر دسته:
                {{ categoryParentName(form) }}
                <b-icon @click="removeCategoryParent(form)" v-if="categoryParentName(form) != null"
                        icon="x-circle-fill"/>
              </label>
              <b-form-group class="mb-4">
                <b-form-input @keyup="searchCategories" class="rounded-pill" placeholder="جست و جو"

                              v-model="searchCategory" type="text"/>
                <div class="col-12 bg-white category-list" v-if="searchBoxStatus">
                  <div class="w-100 mt-2 text-right">
                    <b-icon @click="searchBoxStatus = false" icon="x-circle-fill"/>
                  </div>
                  <div class="category-list-item" @click="selectParentCategory(item)" v-for="item in searchResult">
                    {{ item.name }}
                  </div>

                </div>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
        <b-col lg="2">
          <form-group :validations="$v.form.order">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="ترتیب دسته بندی"
                  class="mb-4"
              >
                <b-form-input
                    v-model="form.order"
                    type="text"
                    placeholder="ترتیب"
                    :class="{ invalid }"
                    class="rounded-pill"
                ></b-form-input>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
        <b-col lg="2">
          <form-group :validations="$v.form.order">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="زبان"
                  class="mb-4"
              >
                <select class="form-control rounded-pill" v-model="form.language_id"> {{ form.language_id }}
                  <option v-for="language in languages" :value="language.id" class="text-dark">
                    {{ language.name }}
                  </option>
                </select>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
      </b-form-row>

      <b-form-row>

        <b-col lg="6">
          <form-group :validations="$v.form.description">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="توضیحات"
                  class="mb-4"
              >
                <b-form-textarea
                    v-model="form.description"
                    placeholder="توضیحات"

                ></b-form-textarea>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" class="text-center">
          <form-group :validations="$v.form.image">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  class="mt-4">

                <b-row>

                  <b-col lg="6" md="6" v-if="mode==='create'">
                    <label class="btn btn-warning d-block rounded-pill text-white btn-sm"
                           :for="`choose_category_image_create`">انتخاب عکس</label>
                    <b-form-file
                        :id="`choose_category_image_create`"
                        browse-text="انتخاب عکس"
                        @change="onFileChange"
                        class="text-center mt-2 mr-2 d-none"
                        v-model="form.image"
                        placeholder="انتخاب عکس"
                    ></b-form-file>
                    <input type="hidden" @change="onFileChange"/>
                  </b-col>

                  <b-col lg="6" md="6" v-else>
                    <label class="btn btn-warning d-block rounded-pill text-white btn-sm"
                           :for="`choose_category_image_${category.id}`">انتخاب عکس</label>
                    <label v-if="form.preview!=null"
                           @click="removeImage(category)"
                           class="btn btn-danger d-block rounded-pill text-white btn-sm">حذف عکس</label>
                    <b-form-file
                        :id="`choose_category_image_${category.id}`"
                        browse-text="انتخاب عکس"
                        @change="onFileChange"
                        class="text-center mt-2 mr-2 d-none"
                        v-model="form.image"
                        placeholder="انتخاب عکس"
                    ></b-form-file>
                    <input type="hidden" @change="onFileChange"/>
                  </b-col>

                  <b-col lg="6" md="6">
                    <div class="">
                      <img alt="" class="rounded w-100 img-category-1" v-if="form.preview"
                           :src="form.preview"/>
                    </div>
                  </b-col>
                </b-row>

                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>

      </b-form-row>

      <b-col lg="12" v-if=" mode==='trash'">
        <b-button pill type="submit" @click="restoreCategory(category)" class="mr-1 mb-1  d-inline-block col-lg-2"
                  variant="success">
          بازیابی
        </b-button>

        <b-button pill @click="forceDelete(category)" class=" mr-1 mb-1 d-inline-block col-lg-2" variant="danger">
          حذف
        </b-button>
      </b-col>

      <b-col lg="12" v-if=" mode==='create'">
        <b-button pill type="submit" class="mr-1 mb-1  d-inline-block col-lg-2"
                  variant="success">
          تایید
        </b-button>

      </b-col>

      <b-col lg="12" v-if="mode==='categories'">
        <b-button pill type="submit" class="mr-1 mb-1  d-inline-block col-lg-2" variant="success">
          تایید
        </b-button>

        <b-button pill @click="deleteCategory(category)" class=" mr-1 mb-1 d-inline-block col-lg-2" variant="danger">
          حذف
        </b-button>
      </b-col>
    </b-form>

  </b-col>
</template>

<script>
import {mapGetters} from 'vuex'
import {slug} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins'
import FormGroup from "../../validator/FormGroup";
import {minValue, numeric, required} from "vuelidate/lib/validators";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";

export default {
  name: "Category",
  components: {FormErrorsManager, FormGroup},
  data() {
    return {
      searchCategory: '',
      searchResult: [],
      searchBoxStatus: false,
      form: {
        id: "",
        name: "",
        description: "",
        image: [],
        parent_id: '',
        parent: {},
        status: 0,
        order: 1,
        language_id: '',
        slug: '',
        preview: ''
      },
    };
  },
  computed: {
    ...mapGetters({
      categories: "Category/getFilteredCategories",
      languages: "Language/getLanguages",
    }),
    categoryOption() {
      let result = []
      if (this.category == undefined) {
        return result
      }
      let categoryChild = this.flatCategories(this.category.children).map(item => {
        return item.id
      });
      categoryChild.push(this.category.id)

      this.flatCategories(this.categories).forEach(item => {
        if (categoryChild.indexOf(item.id) === -1) {
          result.push(item)
        }
      })
      return result
    },
    generateRandomString() {
      return (
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15)
      );
    }
  },
  validations: {
    form: {
      name: {required},
      description: {},
      image: {},
      slug: {required, slug},
      language_id: {required},
      order: {required, numeric, minValue: minValue(1)},
      parent_id: {},
    },
  },
  props: {
    category: {},
    submitMethod: {},
    mode: {
      default: 'categories'
    }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.preview = URL.createObjectURL(file);
    },
    async removeImage(category) {
      await this.$store.dispatch('Category/removeCategoryImage', category).then(async () => {
        this.form.preview = null
      })
    },
    flatCategories,
    deleteCategory(category) {
      if (confirm("آیا از حذف دسته بندی اطمینان دارید؟")) {
        this.$store.dispatch("Category/deleteCategory", category);
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.mode === 'create') {
          this.$store.dispatch("Category/createCategory", this.form)
              .then(() => {
                window.location.reload();
              });
        }

        if (this.mode === 'categories') {
          this.$store.dispatch("Category/updateCategory", this.form)
              .then(() => {
                window.location.reload();
              });
        }
      }


    },
    restoreCategory(category) {
      this.$store.dispatch("Category/restoreCategory", category);
    },
    forceDelete(category) {
      if (confirm("آیا از حذف دائمی اطمینان دارید؟")) {
        this.$store.dispatch("Category/forceDelete", category);
      }
    },
    removeCategoryParent(form) {
      form.parent = null
      form.parent_id = null
    },
    categoryParentName(form) {
      let name = form.parent?.name;
      if (name == undefined) {
        return null
      }
      return name
    },
    async searchCategories() {
      this.$store.commit("Category/setFilters", {key: "search", value: this.searchCategory});
      let req = await this.$store.dispatch('Category/getDashboardCategoriesFlat', this.searchCategory)
      this.searchResult = req.data.data.data
      this.searchBoxStatus = true
    },
    selectParentCategory(item) {
      this.$store.commit("Category/setFilters", {key: "search", value: ''});
      this.searchResult = []
      this.form.parent_id = item.id;
      this.form.parent = item;
      this.searchBoxStatus = false
    }
  },
  mounted() {

    if (this.mode !== 'create') { // mean update mode.
      this.form.id = this.category.id
      this.form.name = this.category.name
      this.form.description = this.category.description
      this.form.preview = this.category.image
      this.form.parent_id = this.category.parent_id
      this.form.parent = this.category.parent
      this.form.slug = this.category.slug
      this.form.order = this.category.order
      this.form.language_id = this.category.language_id
      this.form.status = (this.category.status === 1)
    } else {
      this.form.parent_id = null
      this.form.language_id = this.findAttributeOnSiteInfo('default_language')[0].id
    }

  }
}
</script>

<style scoped>
.img-category-1 {
  height: 120px;
  width: auto !important;
}

.category-list {
  height: 150px;
  position: absolute;
  border: 1px solid #ccc;
  z-index: 111;
  overflow: auto;
  margin: 3px 0;
}

.category-list-item {
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(204, 204, 204, 0.65);
}
</style>